import { createIconInner } from '##/icons/Icon/createIconInner';

import props from './props';
import svg from './svg';

export const IconDrillingPartRightFilled = createIconInner(props, svg);
